<div class="card">
  <div>
    <h3 class="card-title">{{ 'product.moves' | translate }}</h3>
  </div>
  <div class="table-responsive">
    <table class="table m-0">
      <thead>
        <tr>
          <th class="ps-0">{{ 'dateCreated' | translate }}</th>
          <th>{{ 'number' | translate }}</th>
          <th>{{ 'type' | translate }}</th>
          <th>&nbsp;</th>
        </tr>
      </thead>
      <tbody>
        @for (movePack of order.movePacks; track movePack) {
          <tr>
            <td class="ps-1 no-hover text-nowrap">{{ movePack.dateCreated | date: 'dd.MM.yyyy HH:mm' }}</td>
            <td class="no-hover">{{ movePack.number }}</td>
            <td class="no-hover">
              <div class="flex-gap-5">
                @if (movePack.type.id === 'in') {
                  <span class="in-badge" title="{{ movePack.type.id | translate }}">
                    <i class="fas fa-plus-square"></i>
                  </span>
                }
                @if (movePack.type.id === 'out') {
                  <span class="out-badge" title="{{ movePack.type.id | translate }}">
                    <i class="fas fa-minus-square"></i>
                  </span>
                }
                @if (movePack.type.id === 'transfer') {
                  <span class="transfer-badge" title="{{ movePack.type.id | translate }}">
                    <i class="fas fa-exchange-alt"></i>
                  </span>
                }
                @if (movePack.type.id === 'reservation') {
                  <span class="reservation-badge" title="{{ movePack.type.id | translate }}">
                    <i class="fas fa-clock"></i>
                  </span>
                }
                <span>
                  {{ movePack.type.id | translate }}
                </span>
              </div>
            </td>
            <td class="p-1 no-hover">
              <span>
                <a
                  class="btn-second float-right"
                  [routerLink]="['/product-move-pack', movePack.id]"
                  [title]="'open' | translate"
                >
                  {{ 'open' | translate }}
                  <i class="far fa-chevron-right my-auto"></i>
                </a>
              </span>
              <!--            <btn-->
              <!--              [iconPosition]="'right'"-->
              <!--              [icon]="'far fa-chevron-right'"-->
              <!--              [label]="'open'"-->
              <!--              [classes]="['btn-second', 'btn-sm', 'text-nowrap',' d-flex', 'flex-row-reverse', 'ms-auto']"-->
              <!--              [routerLink]="['/product-move-pack', movePack.id]"-->
              <!--            >-->
              <!--            </btn>-->
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>
